<app-mu-modal-dialog-layout
  [title]="title || 'page.delivery.orders.evidence.title' | translate"
  [subTitle]="ignoreSubTitle ? '' : (subTitle || 'page.delivery.orders.evidence.order' | translate)"
  [subTitleValue]="subTitleValue"
  [flagList]="flagList"
  [showFlag]="showFlag"
  [showCloseIcon]="true"
  class="mu-modal-evidences"
>
  <div class="p-grid p-justify-center p-align-center mu-full-width" modalDialogContent>
    <div class="p-col-12 mu-evidence-not-found mu-without-padding" *ngIf="!evidenceList || evidenceList.length === 0">
      <div class="p-grid">
        <div class="p-col-12 mu-without-padding"><i class="fas fa-warning" aria-hidden="true"></i></div>
        <div
          class="p-col-12 mu-evidence-text mu-without-padding"
          [innerHTML]="notFound || ('page.delivery.orders.evidence.notFound' | translate)"
        ></div>
      </div>
    </div>
    <p-galleria
      *ngIf="evidenceList && evidenceList.length > 0"
      [value]="evidenceList"
      [numVisible]="evidenceList?.length > 6 ? 6 : 0"
      class="gallery"
      [showThumbnails]="evidenceList && evidenceList.length > 1"
    >
      <ng-template pTemplate="item" let-evidence>
        <div class="mu-evidence-content" [ngClass]="{ 'mu-evidence-without-thumb': evidenceList.length < 2 }">
          <img class="photo-evidence" [style.background-image]="'url(' + evidence.urlPhoto + ')'" alt="" />
          <img class="mask-evidence" [src]="evidence.urlPhoto" alt="" />
          <div class="p-col-12 mu-evidence-info">
            <div class="p-grid">
              <div class="p-col-12 mu-evidence-address">
                <strong>{{ evidence.address }}</strong>
              </div>
              <div class="p-col-12 mu-evidence-date">
                {{ evidence.date }}
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="thumbnail" let-evidence>
        <img class="photo-thumbnail" [src]="evidence.urlPhoto" alt="" />
      </ng-template>
    </p-galleria>
    <div class="p-col-12 mu-without-padding" *ngIf="evidenceList && evidenceList.length > 0">
      <app-mu-button
        [label]="'common.downloadEvidences' | translate"
        (click)="getEvidenceZip()"
        class="mu-evidence-button"
        [flagList]="flagList"
        [flag]="flagEnum.LOADER"
      ></app-mu-button>
    </div>
  </div>
</app-mu-modal-dialog-layout>
